import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import { showMessage } from "./common.slice";
import { getSessionData } from "utils/common";
import { exportToExcel } from "utils/reportGenerator";

const initialState = {
  currentPageAccounts: 1,
  pageSizeAccounts: 10,
  totalRecordAccounts: 0,
  startApiCallAccountList: false,
  sortMasterAccountArr: [],
  sortMasterBrokerageArr: [],
  sortMasterBrokerageAddArr: [],
  sortMasterPartnershipAddArr: [],
  accountViewData: {},
  accountsList: [],
  accountsLoading: false,
  isAccountUpdated: false,
  searchTextMasterAccount: "",
  accountTypeSelected: "",
  accountLoader: false,
};

export const addAccount = createAsyncThunk("/account/add", (data, { dispatch }) => {
  return new Promise((resolve, reject) => {
    let { userId } = getSessionData();
    //user info
    let mobileInformation = {};
    let segmentArr = [];
    let accountInformation = {};

    accountInformation.accountCode =
      data?.accountType?.label === "Cashbook" ? "CB" : data.accountCode;
    accountInformation.CashBookAuthId = data.authority?.value ? parseInt(data.authority.value) : 0;
    accountInformation.accountName =
      data?.accountType?.label === "Cashbook"
        ? `Cashbook - ${data.authority.label}`
        : data.accountName.trim();
    accountInformation.password = data.password ? data.password : "";
    accountInformation.viewPassword = data.viewPassword ? data.viewPassword : "";
    accountInformation.comment = data.comment ? data.comment : "";
    accountInformation.positionHoldTime = data.positionHoldTime ? data.positionHoldTime : 0;
    accountInformation.accountType = data.accountType.value;
    accountInformation.openingBalance = Number(data.openingBalance);
    // Debit=1, Credit=2, None=3. Trading users default Credit so Opening Balance funds FreeMargin.
    if (data.openingBalanceType === "Debit" || data.openingBalanceType === 1) {
      accountInformation.openingBalanceType = 1;
    } else if (data.openingBalanceType === "Credit" || data.openingBalanceType === 2) {
      accountInformation.openingBalanceType = 2;
    } else {
      accountInformation.openingBalanceType = data?.accountType?.label === "Cashbook" ? 1 : 2;
    }
    accountInformation.subBrokerId = data?.subBrokerId?.value ? data.subBrokerId.value : null;
    accountInformation.partnerId =
      data.partnerId && data.partnerId !== undefined && data.accountType !== 7
        ? data.partnerId.value
        : null;
    accountInformation.joinDate = moment(new Date(data.joinDate)).format();
    accountInformation.expiryDate = data.expiryDate
      ? moment(new Date(data.expiryDate)).format()
      : moment(new Date(data.joinDate)).add(1, "year").format();
    accountInformation.brokerageSharingBySubBroker =
      data.brokerageSharingBySubBroker && data.brokerageSharingBySubBroker !== null
        ? data.brokerageSharingBySubBroker.value
        : null;
    accountInformation.sharingPercentageOfPartner = data.sharingPercentageOfPartner
      ? Number(data.sharingPercentageOfPartner)
      : 0;
    accountInformation.brokerageSharingOfSubBroker = data.brokerageSharingOfSubBroker
      ? Number(data.brokerageSharingOfSubBroker)
      : 0;
    accountInformation.pnlNetSharingPercentage = data.pnlNetSharingPercentage
      ? data.pnlNetSharingPercentage
      : 0;
    accountInformation.pnlGrossSharingPercentage = data.pnlGrossSharingPercentage
      ? data.pnlGrossSharingPercentage
      : 0;
    accountInformation.brokerageSharingOfPartner = data.brokerageSharingOfPartner
      ? Number(data.brokerageSharingOfPartner)
      : 0;
    accountInformation.projectType = 1;
    accountInformation.customerSupportNumber = data.customerSupportNumber;
    accountInformation.mobileNumber = data.mobile_no
      ? data.country_code + "~" + data.mobile_no
      : "";
    accountInformation.stateName = data.stateName;
    accountInformation.cityName = data.cityName;
    accountInformation.reference = data.reference;
    //mobile info
    if (
      data.accountType.value == 8 ||
      data.accountType.value == 4 ||
      data.accountType.value == 3 ||
      data.accountType.value == 2 ||
      data.accountType.value == 10
    ) {
      mobileInformation.isViewOnly = data.isViewOnly == "No" ? false : true;
      mobileInformation.isMAccess = data.isMAccess == "No" ? false : true;
      mobileInformation.isOrderBetweenHighLow = data.isOrderBetweenHighLow == "No" ? false : true;
      mobileInformation.isApplyAutoSquare = data.isApplyAutoSquare == "No" ? false : true;
      mobileInformation.isIntraDayAutoSquare = data.isIntraDayAutoSquare == "No" ? false : true;
      mobileInformation.isM2MClWithLedger = data.isM2MClWithLedger == "No" ? false : true;
      mobileInformation.isOnlyPositionSquareOff =
        data.isOnlyPositionSquareOff == "No" ? false : true;
      mobileInformation.isRollOver = data.isRollOver == "No" ? false : true;
      mobileInformation.positionDataType = data.positionDataType;
      mobileInformation.positionMode = Number(data.positionMode || 1);
      mobileInformation.margin = Number(data.margin) || 0;
      mobileInformation.ledgerBalance = Number(data.ledgerBalance) || 0;
      // Legacy multiples/alerts: UI removed; send safe defaults so create still succeeds.
      mobileInformation.intraDayMultiple = Number(data.intraDayMultiple) || 1;
      mobileInformation.positionMultiple = Number(data.positionMultiple) || 1;
      mobileInformation.optBuyIntraDayMultiple = Number(data.optBuyIntraDayMultiple) || 1;
      mobileInformation.optBuyPositionMultiple = Number(data.optBuyPositionMultiple) || 1;
      mobileInformation.optSellIntraDayMultiple = Number(data.optSellIntraDayMultiple) || 1;
      mobileInformation.optSellPositionMultiple = Number(data.optSellPositionMultiple) || 1;
      mobileInformation.comexIntraDayMultiple = Number(data.comexIntraDayMultiple) || 1;
      mobileInformation.comexPositionMultiple = Number(data.comexPositionMultiple) || 1;
      mobileInformation.forexIntraDayMultiple = Number(data.forexIntraDayMultiple) || 1;
      mobileInformation.forexPositionMultiple = Number(data.forexPositionMultiple) || 1;
      mobileInformation.cryptoIntraDayMultiple = Number(data.cryptoIntraDayMultiple) || 1;
      mobileInformation.cryptoPositionMultiple = Number(data.cryptoPositionMultiple) || 1;
      mobileInformation.lossPercentAlert = Number(data.lossPercentAlert) || 0;
      mobileInformation.closePercentAlert = Number(data.closePercentAlert) || 0;
      data.segment.forEach((element) => {
        segmentArr.push({ segmentId: element.value });
      });
      mobileInformation.mobileInformationSegments = segmentArr;
    } else {
      mobileInformation = null;
    }
    axios
      .post("master/account/create-account", {
        createdBy: userId,
        settingsGroupId: data.settingsGroupId?.value || data.settingsGroupId || null,
        accountInformation,
        mobileInformation: mobileInformation,
      })
      .then(({ data }) => {
        if (data.status == 200) {
          dispatch(showMessage({ message: data.message, varient: "success" }));
          resolve(data);
        } else {
          dispatch(showMessage({ message: data.message }));
          reject();
        }
      })
      .catch((error) => {
        if (error.response) {
          dispatch(showMessage({ message: error.response.data.message }));
        } else if (error.request) {
          dispatch(showMessage({ message: error.request.message }));
        } else {
          dispatch(showMessage({ message: error.message }));
        }
        // reject(error);
      });
  });
});

export const editAccount = createAsyncThunk("/account/edit", (data, { dispatch }) => {
  return new Promise((resolve, reject) => {
    let { userId } = getSessionData();
    //user info
    let mobileInformation = {};
    let segmentArr = [];
    let accountInformation = {};

    accountInformation.accountCode = data.accountCode;
    accountInformation.accountName = data.accountName;
    accountInformation.accountType = data.accountType.value;
    accountInformation.openingBalance = Number(data.openingBalance);
    // Keep stored type if present; edit UI does not send type — Credit for non-Cashbook funding.
    accountInformation.openingBalanceType =
      data.openingBalanceType === "Debit" || data.openingBalanceType === 1
        ? 1
        : data.openingBalanceType === "Credit" || data.openingBalanceType === 2
          ? 2
          : data?.accountType?.label === "Cashbook" || data?.accountTypeName === "Cashbook"
            ? 1
            : 2;
    accountInformation.subBrokerId =
      data.subBrokerId && data.subBrokerId !== undefined && data.accountType !== 6
        ? data.subBrokerId.value
        : null;
    accountInformation.joinDate = moment(data.joinDate).format();
    accountInformation.expiryDate = data.expiryDate
      ? moment(new Date(data.expiryDate)).format()
      : moment(new Date(data.joinDate)).add(1, "year").format();
    accountInformation.brokerageSharingBySubBroker =
      data.brokerageSharingBySubBroker && data.brokerageSharingBySubBroker !== null
        ? data.brokerageSharingBySubBroker.value
        : null;
    accountInformation.sharingPercentageOfPartner = data.sharingPercentageOfPartner
      ? Number(data.sharingPercentageOfPartner)
      : 0;
    accountInformation.brokerageSharingOfSubBroker = data.brokerageSharingOfSubBroker
      ? Number(data.brokerageSharingOfSubBroker)
      : 0;
    accountInformation.pnlNetSharingPercentage = data.pnlNetSharingPercentage
      ? data.pnlNetSharingPercentage
      : 0;
    accountInformation.pnlGrossSharingPercentage = data.pnlGrossSharingPercentage
      ? data.pnlGrossSharingPercentage
      : 0;
    accountInformation.brokerageSharingOfPartner = data.brokerageSharingOfPartner
      ? Number(data.brokerageSharingOfPartner)
      : 0;
    accountInformation.password = data.password ? data.password : "";
    accountInformation.viewPassword = data.viewPassword ? data.viewPassword : "";
    accountInformation.comment = data.comment ? data.comment : "";
    accountInformation.positionHoldTime = data.positionHoldTime ? data.positionHoldTime : 0;
    accountInformation.partnerId =
      data.partnerId && data.partnerId !== undefined && data.accountType !== 7
        ? data.partnerId.value
        : null;
    accountInformation.projectType = 1;
    accountInformation.customerSupportNumber = data.customerSupportNumber;
    accountInformation.mobileNumber = data.mobile_no
      ? data.country_code + "~" + data.mobile_no
      : "";
    accountInformation.stateName = data.stateName;
    accountInformation.cityName = data.cityName;
    accountInformation.reference = data.reference;
    //mobile info
    if (
      data.accountType.value == 8 ||
      data.accountType.value == 4 ||
      data.accountType.value == 3 ||
      data.accountType.value == 2 ||
      data.accountType.value == 10
    ) {
      mobileInformation.isViewOnly = data.isViewOnly == "No" ? false : true;
      mobileInformation.isMAccess = data.isMAccess == "No" ? false : true;
      mobileInformation.isOrderBetweenHighLow = data.isOrderBetweenHighLow == "No" ? false : true;
      mobileInformation.isApplyAutoSquare = data.isApplyAutoSquare == "No" ? false : true;
      mobileInformation.isIntraDayAutoSquare = data.isIntraDayAutoSquare == "No" ? false : true;
      mobileInformation.isM2MClWithLedger = data.isM2MClWithLedger == "No" ? false : true;
      mobileInformation.isOnlyPositionSquareOff =
        data.isOnlyPositionSquareOff == "No" ? false : true;
      mobileInformation.isRollOver = data.isRollOver == "No" ? false : true;
      mobileInformation.positionDataType = data.positionDataType;
      mobileInformation.positionMode = Number(data.positionMode || 1);
      mobileInformation.margin = Number(data.margin) || 0;
      mobileInformation.ledgerBalance = Number(data.ledgerBalance) || 0;
      // Legacy fields still persisted on edit (UI removed); Free Margin module owns live risk.
      mobileInformation.intraDayMultiple = Number(data.intraDayMultiple) || 1;
      mobileInformation.positionMultiple = Number(data.positionMultiple) || 1;
      mobileInformation.optBuyIntraDayMultiple = Number(data.optBuyIntraDayMultiple) || 1;
      mobileInformation.optBuyPositionMultiple = Number(data.optBuyPositionMultiple) || 1;
      mobileInformation.optSellIntraDayMultiple = Number(data.optSellIntraDayMultiple) || 1;
      mobileInformation.optSellPositionMultiple = Number(data.optSellPositionMultiple) || 1;
      mobileInformation.comexIntraDayMultiple = Number(data.comexIntraDayMultiple) || 1;
      mobileInformation.comexPositionMultiple = Number(data.comexPositionMultiple) || 1;
      mobileInformation.forexIntraDayMultiple = Number(data.forexIntraDayMultiple) || 1;
      mobileInformation.forexPositionMultiple = Number(data.forexPositionMultiple) || 1;
      mobileInformation.cryptoIntraDayMultiple = Number(data.cryptoIntraDayMultiple) || 1;
      mobileInformation.cryptoPositionMultiple = Number(data.cryptoPositionMultiple) || 1;
      mobileInformation.lossPercentAlert = Number(data.lossPercentAlert) || 0;
      mobileInformation.closePercentAlert = Number(data.closePercentAlert) || 0;
      data.segment.forEach((element) => {
        segmentArr.push({ segmentId: element.value });
      });
      mobileInformation.mobileInformationSegments = segmentArr;
    } else {
      mobileInformation = null;
    }
    axios
      .post("master/account/update-account", {
        id: data.id,
        createdBy: userId,
        accountInformation,
        mobileInformation: mobileInformation,
      })
      .then(async ({ data: response }) => {
        if (response.status == 200) {
          const settingsGroupId = data.settingsGroupId?.value || data.settingsGroupId || null;
          if (settingsGroupId) {
            await axios.post("settings/settings-group/apply-to-user", {
              settingsGroupId,
              userId: data.id,
            });
          }
          dispatch(showMessage({ message: response.message, varient: "success" }));
          resolve(response);
        } else {
          dispatch(showMessage({ message: response.message }));
          reject(response.message);
        }
      })
      .catch((error) => {
        if (error.response) {
          dispatch(showMessage({ message: error.response.data.message }));
        } else if (error.request) {
          dispatch(showMessage({ message: error.request.message }));
        } else {
          dispatch(showMessage({ message: error.message }));
        }
        reject(error);
      });
  });
});

export const deleteAccount = createAsyncThunk("/account/delete", (data, { dispatch }) => {
  return new Promise((resolve, reject) => {
    //user info
    let { id, deleted } = data;
    axios
      .delete(`master/account/delete-account/${id}/${deleted}`)
      .then(({ data }) => {
        if (data.status == 200) {
          dispatch(showMessage({ message: data.message, varient: "success" }));
          resolve(data);
        } else {
          dispatch(showMessage({ message: data.message }));
          reject(data);
        }
      })
      .catch((error) => {
        if (error.response) {
          dispatch(showMessage({ message: error.response.data.message }));
        } else if (error.request) {
          dispatch(showMessage({ message: error.request.message }));
        } else {
          dispatch(showMessage({ message: error.message }));
        }
        reject(error);
      });
  });
});
export const createInstantAccount = createAsyncThunk(
  "/account/create-instant-account",
  (data, { dispatch }) => {
    let { userId } = getSessionData();
    const obj = {
      createdBy: userId,
      accountName: data?.accountName,
      accountCode: data?.accountCode,
      password: data?.password,
      viewPassword: data?.viewPassword,
      fromClientId: data?.selectedUser?.value,
    };
    return new Promise((resolve, reject) => {
      axios
        .post("master/account/create-instant-account", obj)
        .then(({ data }) => {
          if (data.status === 200) {
            dispatch(showMessage({ message: data.message, varient: "success" }));
            resolve(data);
          } else {
            dispatch(showMessage({ message: data.message }));
            reject(data);
          }
        })
        .catch((error) => {
          if (error.response) {
            dispatch(showMessage({ message: error.response.data.message }));
          } else if (error.request) {
            dispatch(showMessage({ message: error.request.message }));
          } else {
            dispatch(showMessage({ message: error.message }));
          }
          reject(error);
        });
    });
  }
);

export const changeMasterAccountChangeActiveStatus = createAsyncThunk(
  "/account/statuchange",
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      let { id, isActive } = data;
      axios
        .post(`master/account/change-active-status?isActive=${!isActive}`, [id])
        .then(({ data }) => {
          dispatch(setStartPageAccounts(1));
          resolve({ data: data.data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);

export const changeMasterAccountLedgerActiveStatus = createAsyncThunk(
  "/account/statuchange/ledger",
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      let { id, isLedgerInApp } = data;
      axios
        .post(`master/account/change-ledger-in-app-status?isActive=${!isLedgerInApp}`, [id])
        .then(({ data }) => {
          dispatch(setStartPageAccounts(1));
          resolve({ data: data.data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);
export const changeMasterAccountPositionSquareOff = createAsyncThunk(
  "/account/position-square-off",
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      let { id, isOnlyPositionSquareOff } = data;
      axios
        .post(
          `master/account/change-position-square-off-only?isActive=${!isOnlyPositionSquareOff}`,
          [id]
        )
        .then(({ data }) => {
          dispatch(setStartPageAccounts(1));
          resolve({ data: data.data });
        })

        .catch((error) => {
          reject(error);
        });
    });
  }
);

export const getAccountList = createAsyncThunk("/account/get", (data) => {
  return new Promise((resolve, reject) => {
    const session = getSessionData() || {};
    const userId = Number(session.userId ?? session.UserId ?? 0);
    const getAccountObj = {
      id: userId,
      pageNo: data.pageNo,
      pageSize: data.pageSize,
      authId: data?.authId?.value ? parseInt(data.authId.value) : 0,
      roleType: data.roleType,
      searchText: data.searchText,
    };
    const { appendData } = data;
    // Backend overwrites id from JWT; still send a resolved id for older APIs.
    axios
      .post("master/account/get-accounts", getAccountObj)
      .then(({ data }) => {
        if (data?.status && data.status !== 200) {
          reject(data);
          return;
        }
        resolve({ data: data.data, appendData });
      })
      .catch((error) => {
        reject(error);
      });
  });
});

export const getAccountViewData = createAsyncThunk("/account/get/signle", (data, { dispatch }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`master/account/get-user/${data.original.id}`)
      .then(({ data }) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
});
export const instantChangeActiveStatus = createAsyncThunk(
  "/account/instant-change-active-status",
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .get("master/account/instant-change-active-status")
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);
export const getAccountBackup = createAsyncThunk("/account/get/backup", (userid, { dispatch }) => {
  let { userId } = getSessionData();
  return new Promise((resolve, reject) => {
    axios
      .get(`master/account-report/get-account-backup/${userId}`)
      .then(({ data }) => {
        if (data.status === 200 && data?.data?.length > 0) {
          let allAcountBackupData = [];
          data.data.forEach((item) => {
            allAcountBackupData = [...allAcountBackupData, ...item.data];
          });
          exportToExcel({
            apiData: allAcountBackupData,
            fileName: "Account_Backup",
          });
          resolve(data.data);
        } else {
          reject(data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
});

export const masterSlice = createSlice({
  name: "marketWatch",
  initialState,
  reducers: {
    setSortMasterAccount: (state, action) => {
      state.sortMasterAccountArr = action.payload;
    },
    setAccountViewData: (state, action) => {
      state.accountViewData = action.payload;
    },
    setAccountUpdated: (state, action) => {
      state.isAccountUpdated = action.payload;
    },
    setSearchTextMasterAccounts: (state, action) => {
      state.searchTextMasterAccount = action.payload;
    },
    setStartPageAccounts: (state, action) => {
      state.currentPageAccounts = action.payload;
    },
    setStartApiCallAccountsList: (state, action) => {
      state.startApiCallAccountList = action.payload;
    },
    setTotalRecordAccounts: (state, action) => {
      state.totalRecordAccounts = action.payload;
    },
    setAccountTypeSelected: (state, action) => {
      state.accountTypeSelected = action.payload;
    },
    setAccountsList: (state, action) => {
      state.accountsList = action.payload;
    },
    setAccountsLoading: (state, action) => {
      state.accountsLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAccountBackup.pending, (state, action) => {
      state.accountsLoading = true;
    });

    builder.addCase(getAccountBackup.rejected, (state, action) => {
      state.accountsLoading = false;
    });

    builder.addCase(getAccountBackup.fulfilled, (state, action) => {
      state.accountsLoading = false;
    });

    builder.addCase(addAccount.pending, (state, action) => {
      state.accountsLoading = true;
      state.isAccountUpdated = false;
    });

    builder.addCase(addAccount.rejected, (state, action) => {
      state.accountsLoading = false;
      state.isAccountUpdated = false;
    });

    builder.addCase(addAccount.fulfilled, (state, action) => {
      state.accountsLoading = false;
      state.isAccountUpdated = true;
    });

    builder.addCase(createInstantAccount.pending, (state, action) => {
      state.accountsLoading = true;
      state.isAccountUpdated = false;
    });

    builder.addCase(createInstantAccount.rejected, (state, action) => {
      state.accountsLoading = false;
      state.isAccountUpdated = false;
    });

    builder.addCase(createInstantAccount.fulfilled, (state, action) => {
      state.accountsLoading = false;
      state.isAccountUpdated = true;
    });

    builder.addCase(editAccount.pending, (state, action) => {
      state.isAccountUpdated = false;
    });

    builder.addCase(editAccount.rejected, (state, action) => {
      state.isAccountUpdated = false;
    });

    builder.addCase(editAccount.fulfilled, (state, action) => {
      state.isAccountUpdated = true;
    });

    builder.addCase(getAccountList.pending, (state, action) => {
      state.accountsLoading = true;
    });

    builder.addCase(getAccountList.rejected, (state, action) => {
      state.accountsList = [];
      state.totalRecordAccounts = 0;
      state.accountsLoading = false;
    });

    builder.addCase(getAccountList.fulfilled, (state, action) => {
      state.totalRecordAccounts = action.payload.data.totalRecords;
      if (action.payload.appendData) {
        state.accountsList = [...state.accountsList, ...action.payload.data.records];
      } else {
        state.accountsList = action.payload.data.records;
      }
      state.accountsLoading = false;
    });

    //account status chnage
    builder.addCase(changeMasterAccountChangeActiveStatus.pending, (state, action) => {
      state.accountLoader = true;
      state.startApiCallAccountList = false;
    });
    builder.addCase(changeMasterAccountChangeActiveStatus.rejected, (state, action) => {
      state.accountLoader = false;
      state.startApiCallAccountList = false;
    });

    builder.addCase(changeMasterAccountChangeActiveStatus.fulfilled, (state, action) => {
      state.accountLoader = false;
      state.startApiCallAccountList = true;
    });

    builder.addCase(changeMasterAccountPositionSquareOff.pending, (state, action) => {
      state.accountLoader = true;
      state.startApiCallAccountList = false;
    });

    builder.addCase(changeMasterAccountPositionSquareOff.rejected, (state, action) => {
      state.accountLoader = false;
      state.startApiCallAccountList = false;
    });

    builder.addCase(changeMasterAccountPositionSquareOff.fulfilled, (state, action) => {
      state.accountLoader = false;
      state.startApiCallAccountList = true;
    });

    builder.addCase(changeMasterAccountLedgerActiveStatus.pending, (state, action) => {
      state.startApiCallAccountList = false;
    });

    builder.addCase(changeMasterAccountLedgerActiveStatus.rejected, (state, action) => {
      state.startApiCallAccountList = false;
    });

    builder.addCase(changeMasterAccountLedgerActiveStatus.fulfilled, (state, action) => {
      state.startApiCallAccountList = true;
    });

    builder.addCase(getAccountViewData.pending, (state, action) => {
      state.accountViewData = {};
    });

    builder.addCase(getAccountViewData.rejected, (state, action) => {
      state.accountViewData = {};
    });

    builder.addCase(getAccountViewData.fulfilled, (state, action) => {
      action.payload.accountInformation.mobile_no = "";
      action.payload.accountInformation.country_code = "+91";
      if (
        action.payload.accountInformation.mobileNumber &&
        action.payload.accountInformation.mobileNumber.includes("~")
      ) {
        let [country_code, mobile_no] = action.payload.accountInformation.mobileNumber.split("~");
        action.payload.accountInformation.mobile_no = mobile_no;
        action.payload.accountInformation.country_code = country_code;
      }
      state.accountViewData = action.payload;
    });

    builder.addCase(deleteAccount.pending, (state, action) => {
      state.isAccountUpdated = false;
    });

    builder.addCase(deleteAccount.rejected, (state, action) => {
      state.isAccountUpdated = false;
    });

    builder.addCase(deleteAccount.fulfilled, (state, action) => {
      state.isAccountUpdated = true;
    });
  },
});

export const {
  setSortMasterAccount,
  setAccountViewData,
  setAccountUpdated,
  setSearchTextMasterAccounts,
  setStartPageAccounts,
  setStartApiCallAccountsList,
  setTotalRecordAccounts,
  setAccountTypeSelected,
  setAccountsList,
  setAccountsLoading,
} = masterSlice.actions;

export default masterSlice.reducer;
